module.exports = __webpack_public_path__ + "img/Axel_Pairing-Mode_Light_animation_poster.cffc2636.png";